import React from 'react';
import FormWizard3Container from '../../../Componant/Forms/FormLayout/FormWizard3';

const FormWizardThree = () => {
  return (
    <div className='page-body'>
      <FormWizard3Container />
    </div>
  );
};

export default FormWizardThree;
